import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

export const submitContact = (payload) => api.post("/contact", payload);

export const fetchJobs = () => api.get("/jobs").then((r) => r.data);

export const submitApplication = (formData) =>
  api.post("/applications", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
